import { atom } from "jotai";
import type { SharePositionType } from "scmp-sdk";

export type ContentShareWidgetDrawerState = {
  isOpen: boolean;
  position: SharePositionType;
};

export const contentShareWidgetDrawerAtom = atom<ContentShareWidgetDrawerState>({
  isOpen: false,
  position: "article_adhesive",
});
